module.exports = __webpack_public_path__ + "img/0Q3B7497_BlackMatted_MockedUp.a0f41e47.jpg";